"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import useIsMobile from "@/hooks/use-mobile";
import { useClubsFiltersOpenedStore } from "@/stores/clubs-filters-store";
import ClubFilterFormat from "./ClubFilterFormat";
import ClubFilterLocation from "./ClubFilterLocation";
import ClubFilterTheme from "./ClubFilterTheme";
export default function ClubsFilters() {
  const $ = _c(8);
  const filtersRef = useRef(null);
  const setFiltersClosed = useClubsFiltersOpenedStore(_temp);
  const isMobile = useIsMobile();
  let t0;
  let t1;
  if ($[0] !== setFiltersClosed) {
    t0 = () => {
      const handleClickOutside = event => {
        if (filtersRef.current && !filtersRef.current.contains(event.target as Node)) {
          setFiltersClosed();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t1 = [setFiltersClosed];
    $[0] = setFiltersClosed;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = `flex gap-4 md:max-w-[1500px] w-full justify-between border border-light-grey p-4 my-6 rounded-[30px] shadow-md ${isMobile ? "flex-col justify-start items-start" : "flex-row justify-between border"}`;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ClubFilterLocation />;
    t4 = <ClubFilterFormat />;
    t5 = <ClubFilterTheme />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2) {
    t6 = <div ref={filtersRef} className="w-full flex justify-center items-center"><div className={t2}>{t3}{t4}{t5}</div></div>;
    $[6] = t2;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function _temp(state) {
  return state.setFiltersClosed;
}